import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class DocuSignService extends BaseService {
    apiSettingsUrl = environment.apiUrl + '/docu-sign-settings'
    apiDocuSignUrl = environment.apiUrl + '/docu-sign'

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    getDocuSignSettings() {
        return this.get<{
            clientId: string,
            clientSecret: string,
            apiAccountId: string,
            consent: boolean,
            updatedAt: string
        }>(this.apiSettingsUrl)
    }

    saveDocuSignSettings(settings: {
        clientId: string,
        clientSecret: string
    }) {
        return this.post(this.apiSettingsUrl + '/save', settings)
    }


    authDocuSign() {
        return this.get<{
            exists: boolean,
            payload: {
                url: string,
                response_type: string,
                client_id: string,
                scope: string
            }
        }>(this.apiDocuSignUrl + '/authenticate')
    }

    revokeConsent() {
        return this.put(this.apiDocuSignUrl + '/revoke-consent', {})
    }

    setAccessToken(code: string, redirect_uri = location.href) {
        return this.post(this.apiDocuSignUrl + '/token', { code, redirect_uri })
    }

    sendDocument(files: FormData) {
        return this.post(this.apiDocuSignUrl + '/send', files)
    }
}